import { Injectable, inject } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    private snackbar = inject(MatSnackBar);

    public success(message: string) {
        this.snackbar.open(message, 'OK',{
            duration: 2000,
        });
    }

    public error(message: string) {
        this.snackbar.open(message, 'Error', {
            duration: 5000,
        });
    }

    public warning(message: string) {
        this.snackbar.open(message, 'Warning', {
            duration: 2000,
        });
    }

    public info(message: string) {
        this.snackbar.open(message, 'info', {
            duration: 2000,
        });
    }
}